import { IPublicClientApplication } from "@azure/msal-browser";
import { clearCurrentUserCache } from "./currentUser";
import { clearClientBrainCache } from "./clientBrainApi";

export const signOut = async (instance?: IPublicClientApplication): Promise<void> => {
    const account = instance?.getActiveAccount();
    if (instance && account) {
        await instance.logoutPopup({ account, mainWindowRedirectUri: "/" });
    } else {
        const response = await fetch("/auth/logout", { method: "POST", credentials: "same-origin" });
        if (!response.ok) throw new Error("Sign out failed. Please try again.");
    }
    localStorage.removeItem("userInfo");
    clearClientBrainCache();
    clearCurrentUserCache();
};
